import { atom } from 'jotai';

type ReplayVideo = {
  handler: () => void;
};

const $EndRecommendShow = atom(false);
const $ReplayVideo = atom<ReplayVideo>({
  handler: () => void 0,
});

export const PostDetailVideoPlayer = {
  $EndRecommendShow,
  $ReplayVideo,
};
